module.exports = __webpack_public_path__ + "img/2015-10-24.dc1edbb4.jpg";